export default __webpack_public_path__ + "static/sams-1e5f95d39292ed58e8a8be6f9d21000f.webp";